import "./MinhaBibliotecaAluno.css";

import TabelaEmprestimoAluno from "../../Componets/TabelaEmprestimoAluno";
import TabelaHistoricoDeLeituraAluno from "../../Componets/TabelaHistoricoDeLeituraAluno";

export default function MinhaBibliotecaAluno() {
  return (
    <div className="container_minhaBibliotecaAluno">
      <h1>Minha Biblioteca</h1>
      <TabelaEmprestimoAluno />
      <TabelaHistoricoDeLeituraAluno />
    </div>
  );
}
